import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './stores/index'

if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    // 如果你返回的是 Promise.reject(true)，则 event.reason === true
    if (event.reason === true) {
      event.preventDefault();
    }
    // 或者如果你返回的是 reject(new Error('操作失败'))，可以这样判断：
    // if (event.reason instanceof Error && event.reason.message === '操作失败') {
    //   event.preventDefault();
    // }
  });

  window.addEventListener('error', (event) => {
    // 如果需要的话，也可以对 error 事件做类似处理
    if (event.error === true) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store} >
    <App />
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
